import { render, staticRenderFns } from "./PopOrderDetailCard.vue?vue&type=template&id=386bd704&scoped=true&"
import script from "./PopOrderDetailCard.vue?vue&type=script&lang=js&"
export * from "./PopOrderDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderDetailCard.vue?vue&type=style&index=0&id=386bd704&prod&lang=scss&"
import style1 from "./PopOrderDetailCard.vue?vue&type=style&index=1&id=386bd704&prod&lang=scss&scoped=true&"
import style2 from "./PopOrderDetailCard.vue?vue&type=style&index=2&id=386bd704&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386bd704",
  null
  
)

export default component.exports